module.exports = __webpack_public_path__ + "static/media/16.jpg.bec93957.webp";